const {
  onlyNumericNormalize,
  zipCodeRegexNumeric,
  SPACE
} = require('../helpers');

const states = {
  'Phnom Penh': 'Phnom Penh',
  'Banteay Meanchey': 'Banteay Meanchey',
  Battambang: 'Battambang',
  'Kampong Cham': 'Kampong Cham',
  'Kampong Chhnang': 'Kampong Chhnang',
  'Kampong Speu': 'Kampong Speu',
  'Kampong Thom': 'Kampong Thom',
  Kampot: 'Kampot',
  Kandal: 'Kandal',
  'Koh Kong': 'Koh Kong',
  Kep: 'Kep',
  Kratié: 'Kratié',
  Mondulkiri: 'Mondulkiri',
  'Oddar Meanchey': 'Oddar Meanchey',
  Pailin: 'Pailin',
  'Preah Sihanouk': 'Preah Sihanouk',
  'Preah Vihear': 'Preah Vihear',
  Pursat: 'Pursat',
  'Prey Veng': 'Prey Veng',
  Ratanakiri: 'Ratanakiri',
  'Siem Reap': 'Siem Reap',
  'Stung Treng': 'Stung Treng',
  'Svay Rieng': 'Svay Rieng',
  Takéo: 'Takéo',
  'Tboung Khmum': 'Tboung Khmum'
};

const stateOptions = [];
for (const key of Object.keys(states)) {
  stateOptions.push({ value: key, name: states[key] });
}

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Cambodia',
  code: 'KH',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town' },
    stateCode: {
      type: 'array',
      array: stateOptions,
      label: 'Province',
      width: 0.5
    },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  states,
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', SPACE, 'stateCode', SPACE, 'zipCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['stateCode', 'zipCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 numbers, 12203'
    }
  ]
};
